export interface Agent {
  corporateHousing: boolean | null
  currentStatus: Status | null
  dialpadUserId: string | null
  id: number
  lastStatusChange: Status | null
  managerUserId: number | null
  name: string | null
  role: string | null
  standard: boolean | null
  supervisor: Agent | null
  userId: number
}

export enum Status {
  Available = 'Available',
  Busy = 'Busy',
  Unavailable = 'Unavailable',
}

export interface BookingAgent {
  id: number
  name: string | null
}
